import { createSelector } from "@reduxjs/toolkit";
import { CondimentInterface, CondimentState } from "../../entities/Condiment";
import { RootState } from "../../store/store";

export const getRoot = (state: RootState) => state.condiment;

export const getCondiments = createSelector(
  [getRoot],
  (condimentState: CondimentState) => {
    const condiments = condimentState.data.condiments as CondimentInterface[];

    const [spices, herbs] = condiments.reduce(
      (result: any, element: CondimentInterface) => {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        result[element.condimentTypeId === 1 ? 0 : 1].push(element);
        return result;
      },
      [[], []],
    );

    return {
      spices,
      herbs,
    };
  },
);

export const getIsLoadingCondiments = createSelector(
  [getRoot],
  (condimentState: CondimentState) => condimentState.isLoading,
);

export const getCombinedCondiments = createSelector(
  [getRoot],
  (condimentState: CondimentState) => condimentState.data.condiments,
);

export const getCombinedCondimentsIds = createSelector(
  [getRoot],
  (condimentState: CondimentState) =>
    condimentState.data.condiments.map((item) => item.id),
);

export const getSelectedCondiments = createSelector(
  [getRoot],
  (condimentState: CondimentState) =>
    condimentState.data.condiments.filter((item) => item.meta.selected),
);
export const getSelectedCondimentsIds = createSelector(
  [getRoot],
  (condimentState: CondimentState) =>
    condimentState.data.condiments
      .filter((item) => item.meta.selected)
      .map((item) => item.id),
);
